import PropTypes from 'prop-types';

const Popup = ({ children }) => (
  <div className="popup">
    <div className="popup-background">
      <div className="content">
        {children}
      </div>
    </div>
  </div>
);

Popup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Popup;
